import { DeliveryApi, DeliveryQuote } from 'kiolyn-api';
import IDeliveryRepository from '../domain/repositories/IDeliveryRepository';

export default class DeliveryRepository implements IDeliveryRepository {
  private readonly api: DeliveryApi;

  constructor(basePath: string) {
    this.api = new DeliveryApi({
      basePath
    });
  }

  public async getQuote(
    storeid: string,
    origin: string,
    destination: string,
    dropoffTime?: string,
    orderValue?: number
  ): Promise<DeliveryQuote> {
    try {
      const r = await this.api.getQuote(
        storeid,
        origin,
        destination,
        dropoffTime,
        orderValue
      );
      return r.data;
    } catch (err) {
      const { detail } = err.response.data;
      if (detail && detail.length > 0) {
        throw new Error(detail);
      } else {
        throw err;
      }
    }
  }
}
